import { createSlice } from '@reduxjs/toolkit';

export const cartAdditionItems = createSlice({
  name: 'cartAdditionItems',
  initialState: {
    data: [],
  },

  reducers: {
    setCartAdditionItems: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setCartAdditionItems } = cartAdditionItems.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getCartAdditionItems = (state) => state.cartAdditionItems.data;

export default cartAdditionItems.reducer;
